<div style="padding-top: 100px">
  @if (!isLoadingSpinner) {
  <div class="row">
    <div class="container-fluid justify-content-center col-lg-4 col-md-8 col-sm-8">
      @if (isSuccessfulFormSubmission) {
      <output
        oke-toast
        popover
        aria-live="polite"
        id="registration-status"
        class="is-success"
        title="Registration Completed"
        body='Clicking <a href="/login">here</a> will take you to the Customer Portal sign-in page. Use your existing ONEOK credentials to sign in.'
        style="margin-block-start: 0"
      ></output>
      } @if (!validUserEmail && !registerForm && emailForm) {
      <div class="email-form-container">
        <form class="m-3 p-1" [formGroup]="emailForm" (ngSubmit)="submitEmail()">
          <h6 class="heading heading--component text--allcaps mt-4">Enter Your Email</h6>
          <div class="form-group row mb-2">
            <label class="col-form-label" for="manualEmailId"
              >Please provide the Email to complete the invitation process</label
            >
            <label for="manualEmailId" class="col-form-label">Email*</label>
            <input
              class="form-control"
              class="inputText"
              id="manualEmailId"
              type="text"
              placeholder="Email.."
              formControlName="email"
              [class]="{ 'is-invalid': (emailForm.get('email')?.touched || emailForm.get('email')?.dirty) && !emailForm.get('email')?.valid }"
            />
            @if (emailForm.get('email')?.touched || emailForm.get('email')?.dirty) {
            <span class="invalid-feedback">
              @if (emailForm.get('email')?.errors?.required) {
              <span> Please enter your Email. </span>
              } @if (!emailForm.get('email')?.valid && !emailForm.get('email')?.errors?.required) {
              <span> Please enter valid Email. </span>
              }
            </span>
            }
          </div>
          <div class="form-part text-center">
            <button
              type="submit"
              class="input input--btn"
              style="cursor: pointer"
              [class]="{ disabled: emailForm.invalid }"
            >
              <span>Continue</span>
            </button>
          </div>
        </form>
      </div>
      } @if (validUserEmail && registerForm) {
      <div class="email-form-container">
        <form class="m-3 p-1" [formGroup]="registerForm" (ngSubmit)="registerSecureAuth()">
          <h6 class="heading heading--component text--allcaps">Complete My Profile</h6>
          <div class="form-group row mb-2">
            <label class="col-form-label" for="firstNameId">First Name*</label>
            <input
              class="form-control"
              class="inputText"
              id="firstNameId"
              type="text"
              placeholder="First Name.."
              formControlName="firstName"
              [class]="{ 'is-invalid': (registerForm.get('firstName')?.touched || registerForm.get('firstName')?.dirty) && !registerForm.get('firstName')?.valid }"
            />
            <span class="invalid-feedback">
              @if (registerForm.get('firstName')?.errors?.required) {
              <span> Please enter your first name. </span>
              } @if (registerForm.get('firstName')?.errors?.maxlength) {
              <span> The first Name must be less than 15 characters. </span>
              }
            </span>
          </div>

          <div class="form-group row mb-2">
            <label class="col-form-label" for="lastNameId">Last Name*</label>
            <input
              class="col-form-control"
              class="inputText"
              id="lastNameId"
              type="text"
              placeholder="Last Name.."
              formControlName="lastName"
              [class]="{ 'is-invalid': (registerForm.get('lastName')?.touched || registerForm.get('lastName')?.dirty) && !registerForm.get('lastName')?.valid }"
            />
            <span class="invalid-feedback">
              @if (registerForm.get('lastName')?.errors?.required) {
              <span> Please enter your last name. </span>
              } @if (registerForm.get('lastName')?.errors?.maxlength) {
              <span> The last Name must be less than 15 characters. </span>
              }
            </span>
          </div>

          <div class="form-group row mb-2">
            <label class="col-form-label" for="companyNameId">Legal Company Name*</label>
            <input
              class="form-control"
              class="inputText"
              id="companyNameId"
              type="text"
              placeholder="Legal Company Name.."
              formControlName="companyName"
              [class]="{ 'is-invalid': (registerForm.get('companyName')?.touched || registerForm.get('companyName')?.dirty) && !registerForm.get('companyName')?.valid }"
            />
            <span class="invalid-feedback">
              @if (registerForm.get('companyName')?.errors?.required) {
              <span> Please enter your Company name. </span>
              } @if (registerForm.get('companyName')?.errors?.maxlength) {
              <span> The Company name must be less than 50 characters. </span>
              }
            </span>
          </div>

          <div class="form-group row mb-2">
            <label class="col-form-label" for="emailId">Email*</label>
            <input
              class="form-control"
              class="inputText input disabled"
              id="emailId"
              type="text"
              placeholder="Email.."
              formControlName="email"
              [disabled]="true"
              [class]="{ 'is-invalid': (registerForm.get('email')?.touched || registerForm.get('email')?.dirty) && !registerForm.get('email')?.valid }"
            />
            @if (registerForm.get('email')?.touched || registerForm.get('email')?.dirty) {
            <span class="invalid-feedback">
              @if (registerForm.get('email')?.errors?.required) {
              <span> Please enter your Email. </span>
              } @if (!registerForm.get('email')?.valid && !registerForm.get('email')?.errors?.required) {
              <span> Please enter valid Email. </span>
              }
            </span>
            }
          </div>

          <div class="form-group row mb-2">
            <label class="col-form-label" for="mobileId">Mobile</label>
            <input
              class="form-control"
              class="inputText"
              id="mobileId"
              type="text"
              placeholder="Mobile.."
              formControlName="mobile"
              [class]="{ 'is-invalid': (registerForm.get('mobile')?.touched || registerForm.get('mobile')?.dirty) && !registerForm.get('mobile')?.valid }"
            />
            @if (registerForm.get('mobile')?.touched || registerForm.get('mobile')?.dirty) {
            <span class="invalid-feedback">
              @if (!registerForm.get('mobile')?.errors?.valid) {
              <span> Please enter valid Mobile Number. </span>
              }
            </span>
            }
          </div>
          @if (!isCusUser && !isAdUser) {

          <div class="form-group row mb-2">
            <label class="col-form-label" for="passwordId">Password*</label>
            <input
              class="form-control"
              class="inputText"
              id="passwordId"
              type="password"
              placeholder="Password.."
              formControlName="pin"
              [class]="{ 'is-invalid': (registerForm.get('pin')?.touched || registerForm.get('pin')?.dirty) && !registerForm.get('pin')?.valid }"
            />

            <span class="invalid-feedback">
              @if (registerForm.get('pin')?.errors?.required) {
              <span> Please enter your password. </span>
              } @if (!registerForm.get('pin')?.valid && !registerForm.get('pin')?.errors?.required) {
              <span class="col-md-10">
                Password must be at least 8 characters in length, including a mixture of uppercase, lowercase, numbers
                and any of these special characters &#64;#$%^&+!=.
              </span>
              }
            </span>
          </div>

          <div class="form-group row mb-4">
            <label class="col-form-label" for="confirmPinId">Confirm Password*</label>
            <input
              class="form-control"
              class="inputText"
              id="confirmPinId"
              type="password"
              placeholder="Confirm Password.."
              formControlName="confirmPin"
              [class]="{ 'is-invalid': (registerForm.get('confirmPin')?.touched || registerForm.get('confirmPin')?.dirty) && !registerForm.get('confirmPin')?.valid }"
            />
            <span class="invalid-feedback">
              @if (registerForm.get('confirmPin')?.errors?.required) {
              <span> Please confirm your Password. </span>
              } @if (registerForm.get('confirmPin')?.errors?.confirmPasswordValidator) {
              <span> Passwords don't match. </span>
              }
            </span>
          </div>

          }

          <div class="form-part text-center">
            <button
              type="submit"
              class="input input--btn"
              style="cursor: pointer"
              [class]="{ disabled: registerForm.invalid }"
            >
              <span>Register</span>
              <span
                class="spinner-border spinner-border-sm"
                id="loading-spinner"
                role="status"
                [class]="{ 'd-none': !isLoadingSpinner }"
              ></span>
            </button>
          </div>
        </form>
      </div>
      }
    </div>
  </div>
  }
</div>
@if (isLoadingSpinner) {
<div class="text-center api-loader">
  <div class="spinner-grow ms-1" role="status"></div>
  <div class="spinner-grow ms-1" role="status"></div>
  <div class="spinner-grow ms-1" role="status"></div>
</div>
}
